import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AngularWebStorageModule } from 'angular-web-storage';

import { AppComponent } from './app.component';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared/shared.module';
import { ScrollToModule } from '@hkjeffchan/ngx-scroll-to';
import { TokenInterceptor } from '@app/shared/auth/token-interceptor';
import { ToastrModule } from 'ngx-toastr';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FlatpickrModule } from 'angularx-flatpickr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { JoyrideModule } from 'ngx-joyride';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { AuthenticationModule } from './authentication/authentication.module';
import { EnvironmentService } from '@env/environment.service';
import { initializeSplit } from './shared/initializer/initializeSplit';
import { SplitService } from './shared/services/helpers/split.service';
import { AuthService } from '@app/shared/auth/auth.service';

export function initializeApp(environmentService: EnvironmentService) {
    return (): Promise<void> => {
      return environmentService.initializeTenantEnvironment();
    };
  }


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    AngularWebStorageModule,
    AppRoutingModule,
    CoreModule,
    FilterPipeModule,
    AuthenticationModule,
    SharedModule,
    NgxSpinnerModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    ToastrModule.forRoot({ closeButton: true, timeOut: 3000 }),
    ScrollToModule.forRoot(),
    JoyrideModule.forRoot(),
    NgbModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
        provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [EnvironmentService],
        multi: true
    },
    {
        provide: APP_INITIALIZER,
        useFactory: initializeSplit,
        deps: [SplitService],
        multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
